<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Voeg een nieuwe functie toe</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeNewPositionDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="pa-4 ma-0" v-if="feedback" :value="true" type="warning">{{
      feedback
    }}</v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="AddPositionForm" lazy-validation>
        <v-text-field
          label="Naam"
          v-model="newPosition.name"
          prepend-inner-icon="assignment"
          required
          outlined
          hide-details
          :color="companyPrimaryColor"
          class="mt-4"
          :background-color="$vuetify.theme.themes[theme].menu"
        ></v-text-field>
        <v-text-field
          label="Omzet per uur"
          v-model.number="newPosition.revenue"
          type="number"
          autocomplete
          hint="Doelstelling voor deze functie"
          :color="companyPrimaryColor"
          class="mt-4"
          outlined
          :background-color="$vuetify.theme.themes[theme].menu"
          persistent-hint
          prepend-inner-icon="euro_symbol"
          required
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeNewPositionDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              :color="companySecondaryColor"
              @click="addPosition()"
            >
              Functie toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/compat/app";

export default {
  name: "add-position-form",
  props: {
    activeCompData: Object,
  },

  data() {
    return {
      feedback: null,
      newPosition: {
        name: null,
        revenue: null,
      },
    };
  },

  methods: {
    closeNewPositionDialog() {
      this.$emit("newPositionDialogChange", false);
      this.newPosition.name = null;
      this.newPosition.revenue = null;
    },

    addPosition() {
      if (this.newPosition.name && this.newPosition.revenue) {
        this.feedback = null;
        db.collection("positions")
          .add({
            name: this.newPosition.name,
            revenue: this.newPosition.revenue,
            compId: this.activeCompData.id,
            deleted: {
              deleted: false,
            },
          })
          .then(() => {
            this.$emit("updateData");
            this.closeNewPositionDialog();
            this.$refs.AddPositionForm.reset();
          })
          .catch((error) => {
            console.error("Error adding position: ", error);
          });
      } else {
        this.feedback = "Vul alle velden in om een functie toe te voegen";
      }
    },
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>
